

































import { Component } from "vue-property-decorator";
import { Base } from "@/components/common/base";
import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";
import { dealService } from "@/shared";
import { RfidLabelViewModel } from "@/models/inventory/vehicle.inventory";
import { VFields } from "@/models/v-fields";
import { Utils } from "@/helper/utils";

@Component({
    props: ["methodName", "progress"],

    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    }
})
export default class VehicleWholeSaleListingPage extends Base {
    public loading: boolean = false;
    public formLoading: boolean = false;
    public zebraPrinters: any = [{ name: "No printers found", uid: "" }];
    // public selectedPrinter = {};
    public rfidLabelModel: RfidLabelViewModel = {
        color: "",
        make: "",
        model: "",
        modelYear: "",
        stockNumber: "",
        vin: "",
        selectedPrinter: {},
        testLabelValue: ""
    };
    public form: any = {};
    public formFields: Array<VFields<any>> = [];

    public setFields(): void {
        this.formFields = [
            {
                key: 'selectedPrinter',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    label: "Zebra Printers",
                    required: true,
                    disabled: false,
                    items: this.zebraPrinters,
                    value: 'uid',
                    text: 'name',
                    altag: 'Zebra Printers',
                    loading: false,
                    rules: [
                        v => this.requiredForObject('Zebra Printers', v)
                    ],
                    events: {
                        onChange: (items, value) => {
                            if (items.length > 0) {
                                if (items[0].uid && items[0].uid != null && items[0].uid != "") {
                                    this.setDefaultPrinter(items[0]);
                                }
                            }
                            else {
                                this.showAlert(false, items.toString());
                            }
                        },
                    },
                    elementClass: 'col col-xs-12 col-sm-12 col-md-12 col-lg-12 float-left'
                },
            },
            {
                key: 'vin',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: "VIN",
                    required: true,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.required('Name', v),
                    ],
                    elementClass: 'col col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left'
                },
            },
            {
                key: 'stockNumber',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: "Stock Number",
                    required: true,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.required('Name', v),
                    ],
                    elementClass: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left'
                },
            },
            {
                key: 'make',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: "Make",
                    required: true,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.required('Name', v),
                    ],
                    elementClass: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left'
                },
            },
            {
                key: 'model',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: "Model",
                    required: true,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.required('Name', v),
                    ],
                    elementClass: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left'
                },
            },
            {
                key: 'modelYear',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: "Model Year",
                    required: true,
                    disabled: false,
                    loading: false,
                    type: 'number',
                    rules: [
                        v => this.required('Name', v),
                    ],
                    elementClass: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left'
                },
            },
            {
                key: 'color',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: "Color",
                    required: true,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.required('Name', v),
                    ],
                    elementClass: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left'
                },
            },
            {
                key: 'testLabelValue',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: "Rfid Tag Value",
                    required: true,
                    disabled: false,
                    loading: false,
                    elementClass: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left'
                },
            },
        ];
    }

    // Create a new instance of the object
    public browserPrint: ZebraBrowserPrintWrapper = new ZebraBrowserPrintWrapper();

    public async mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'rfidlabel');

        this.setFields();
        await this.getZebraDevices();
    }

    public async getZebraDevices() {
        try {
            this.loading = true;
            this.formlyShowSkeleton(this.formFields);
            await dealService.postLog("getZebraDevices initiated");
            // Select default printer
            const availablePrinters = await this.browserPrint.getAvailablePrinters();
            this.zebraPrinters = availablePrinters;
            await dealService.postLog(`zebra devices list ${JSON.stringify(this.zebraPrinters)}`);
        } catch (error) {
            await dealService.postLog(`getZebraDevices exception ${error}`);
        } finally {
            this.loading = false;
            this.formlyHideSkeleton(this.formFields);
            this.setFields();
        }
    }

    public async setDefaultPrinter(selectedPrinterUid) {
        try {
            await dealService.postLog(`setDefaultPrinter - ${selectedPrinterUid}`);
            // Set the printer
            this.browserPrint.setPrinter(selectedPrinterUid);
            await dealService.postLog(`setDefaultPrinter setPrinter success - ${selectedPrinterUid}`);

            var printerDetails = this.browserPrint.getPrinter();
            await dealService.postLog(`setDefaultPrinter getPrinter - ${JSON.stringify(printerDetails)}`);
        }
        catch (error) {
            await dealService.postLog(`setDefaultPrinter exception ${error}`);
        }
    }

    public validateManualRfidLabelPrint(): Vue & { validate: () => boolean } {
        return this.$refs.manualRfidLabelPrintForm as Vue & { validate: () => boolean };
    }

    public async printLabel() {
        if (this.validateManualRfidLabelPrint().validate()) {
            var validateRes = this.$validator.errors.items.length > 0;
            if (validateRes) {
                this.showAlert(false, 'Please Enter Valid Details');
                return;
            }

            try {

                this.formlyShowSkeleton(this.formFields);
                // ZPL script to print a simple barcode

                // Check printer status
                const printerStatus = await this.browserPrint.checkPrinterStatus();
                await dealService.postLog(`RfidLabelPrinting fileBunkerManual printLabel: printerStatus- ${JSON.stringify(printerStatus)}`);

                const { stockNumber, vin, make, model, modelYear, color } = this.rfidLabelModel;
                const zpl = `^XA
                    ^PW400
                    ^LL800
                    ^FO00,80,0^GB400,300,2,B,1^FS
                    ^FO20,120^A0N,30,30^FDVIN: ${vin}^FS
                    ^FO20,160^A0N,30,30^FDStock Number: ${stockNumber}^FS
                    ^FO20,200^A0N,25,25^FDMake: ${make}^FS
                    ^FO20,240^A0N,25,25^FDModel: ${model}^FS
                    ^FO20,280^A0N,25,25^FDModel Year: ${modelYear}^FS
                    ^FO20,320^A0N,25,25^FDColor: ${color}^FS
                ^XZ`;

                await dealService.postLog(`RfidLabelPrinting fileBunkerManual printLabel: zplFormat- ${zpl.toString()}`);

                await this.browserPrint.print(zpl.toString())
                    .then(async (resolve) => {
                        await dealService.postLog(`RfidLabelPrinting fileBunkerManual printLabel success: print command executed with zpl {@resolve} ${resolve}`);
                        this.showAlert(true, "Request has been sent for printing");
                    }).catch(async (error) => {
                        await dealService.postLog(`RfidLabelPrinting fileBunkerManual printLabel exception : print command executed with zpl {@error} ${error}`);
                        this.showAlert(false, error);
                    });
                await dealService.postLog(`RfidLabelPrinting fileBunkerManual printLabel : print command executed with zpl ${zpl.toString()}`);

            } catch (error) 
            {
                await dealService.postLog(`RfidLabelPrinting fileBunkerManual printLabel : exception ${error}`);
            } 
            finally {
                this.rfidLabelModel.selectedPrinter = {};
                this.rfidLabelModel.color = "";
                this.rfidLabelModel.make = "";
                this.rfidLabelModel.model = "";
                this.rfidLabelModel.modelYear = "";
                this.rfidLabelModel.stockNumber = "";
                this.rfidLabelModel.vin = "";
                this.formlyHideSkeleton(this.formFields);
            }
        }
    }

    public zplFormats: any[] = 
    [
        {
            0 : `
            ^XA
                ^RS8,A              
                ^RU,TAGID:,#        
                ^RFR,E,1,4          
            ^XZ`
        },
        {
            1: `
            ^XA
                ^RS8,A                
                ^RT1,0,4,E,3,N,N      
            ^XZ`
        },
        {
            2:`
            ^XA
                ^RS8,A               
                ^RI1,E,3,N          
            ^XZ`
        },
        {
            3:`
            ^XA
                ^RS8,A               
                ^RA1,E,3,N,0           
            ^XZ`
        }
    ];

    public async readLabelData() 
    {
        try {

            await this.browserPrint.read()
            .then(async(result)=>{
                this.rfidLabelModel.testLabelValue = result;
                await dealService.postLog(`RfidLabelPrinting fileBunkerManual readLabelData: {@response} ${this.rfidLabelModel.testLabelValue}`);
            }).catch(async(error)=>{

                await dealService.postLog(`RfidLabelPrinting fileBunkerManual readLabelData: exception {@error} ${error}`);
            });
            await dealService.postLog(`RfidLabelPrinting fileBunkerManual readLabelData {@response} ${this.rfidLabelModel.testLabelValue}`);

            
            // Read RFID data
            for (let index = 0; index < this.zplFormats.length; index++) {
                const selectedFormat = this.zplFormats[index];
                try{
                    
                    await this.browserPrint.print(selectedFormat[index])
                    .then(async (response) => {
                        await dealService.postLog(`RfidReading fileBunkerManual readLabelData : RFID data read successfully {@zplformat} - ${selectedFormat[index]} and {@response} - ${response}`);
                    })
                    .catch(async (error) => {
                        await dealService.postLog(`RfidReading fileBunkerManual readLabelData : exception {@zplformat} - ${selectedFormat[index]} and {@error} - ${error}`);
                    });
    
    
                    await this.browserPrint.read()
                    .then(async(result)=>{

                        this.rfidLabelModel.testLabelValue = result;
                        await dealService.postLog(`RfidLabelPrinting fileBunkerManual readLabelData : read command {@response} ${this.rfidLabelModel.testLabelValue}`);
                    })
                    .catch(async(error)=>{
                        await dealService.postLog(`RfidLabelPrinting fileBunkerManual readLabelData : exception {@error} ${error}`);
                    });
                    await dealService.postLog(`RfidLabelPrinting fileBunkerManual readLabelData : read command {@response} ${this.rfidLabelModel.testLabelValue}`);

                }
                catch(error)
                {
                    await dealService.postLog(`RfidLabelPrinting fileBunkerManual readLabelData : exception {@selectedFormat} - ${selectedFormat[index]} and {@error} - ${error}`);
                }
            }
        }
        catch (error) {
            await dealService.postLog(`RfidLabelPrinting fileBunkerManual readLabelData : exception ${error}`);
        }
    }

    public async writeVinToLabel()
    {
        try
        {
            var vehicleVin = "1234567890ABCDEF1234";
            if(this.rfidLabelModel.testLabelValue)
                vehicleVin = this.rfidLabelModel.testLabelValue;

            // Read RFID data
            const rfidWriteFormat = `
            ^XA
                ^RS8,A
                ^WT1,3,N,Y,H,1
                ^FD${vehicleVin}^FS
            ^XZ`;

            await dealService.postLog(`RfidLabelPrinting fileBunkerManual writeVinToLabel executed: {@zpl} - ${rfidWriteFormat}`);

            await this.browserPrint.print(rfidWriteFormat)
            .then(async (response) => {
                this.showAlert(true, "Request sent to printer");
                if(response != null && response != undefined){
                    await dealService.postLog(`RfidLabelPrinting fileBunkerManual writeVinToLabel: {@rfidReadFormat} - ${rfidWriteFormat} and {@response} - ${response}`);
                }
            })
            .catch(async (error) => {
                await dealService.postLog(`RfidLabelPrinting fileBunkerManual writeVinToLabel exception: {@error} - ${error}`);
            });

        }catch(error)
        {
            await dealService.postLog(`RfidLabelPrinting fileBunkerManual writeVinToLabel : exception ${error}`);
        }
    }

    public getPrinterConfig()
    {
        window.open(Utils.WEB_BASE_URL + "/rfid/printlabel");
    }
}

